export enum ActionType {
    IS_FAVORITED,
    IS_UNFAVORITED,
    REQUEST_FAVORITE,
    RECEIVE_FAVORITE,
    ERROR_FAVORITE
}

export interface IAction {
    type: ActionType;
    value?: any;
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/favorites/classes/actiontype.ts